export default __webpack_public_path__ + "static/media/20.5f5aeb71.jpg";